
import React, { useState, useEffect } from 'react';
import {
  Container,
  CssBaseline,
  AppBar,
  Toolbar,
  Typography,
  Card,
  CardContent,
  TextField,
  Button,
  Stack,
} from '@mui/material';

function App() {
  const [paceMinutes, setPaceMinutes] = useState('');
  const [paceSeconds, setPaceSeconds] = useState('');
  const [speed, setSpeed] = useState('');
  const [distance, setDistance] = useState('42.195');
  const [finishTime, setFinishTime] = useState('');
  const [lastEdited, setLastEdited] = useState(null);

  useEffect(() => {
    if (lastEdited !== 'pace') return;
    const paceMin = parseInt(paceMinutes, 10);
    const paceSec = parseInt(paceSeconds, 10);
    if (!isNaN(paceMin) || !isNaN(paceSec)) {
      const totalPaceSeconds = (paceMin || 0) * 60 + (paceSec || 0);
      if (totalPaceSeconds > 0) {
        const calculatedSpeed = 3600 / totalPaceSeconds;
        setSpeed(calculatedSpeed.toFixed(2));
      } else {
        setSpeed('');
      }
    }
  }, [paceMinutes, paceSeconds, lastEdited]);

  useEffect(() => {
    if (lastEdited !== 'speed') return;
    const speedValue = parseFloat(speed);
    if (!isNaN(speedValue) && speedValue > 0) {
      const totalPaceSeconds = 3600 / speedValue;
      const minutes = Math.floor(totalPaceSeconds / 60);
      const seconds = Math.round(totalPaceSeconds % 60);
      setPaceMinutes(String(minutes));
      setPaceSeconds(String(seconds).padStart(2, '0'));
    } else {
      setPaceMinutes('');
      setPaceSeconds('');
    }
  }, [speed, lastEdited]);

  const handlePaceMinutesChange = (e) => {
    setLastEdited('pace');
    setPaceMinutes(e.target.value);
  };

  const handlePaceSecondsChange = (e) => {
    setLastEdited('pace');
    setPaceSeconds(e.target.value);
  };

  const handleSpeedChange = (e) => {
    setLastEdited('speed');
    setSpeed(e.target.value);
  };

  const calculateFinishTime = () => {
    const paceMin = parseInt(paceMinutes, 10);
    const paceSec = parseInt(paceSeconds, 10);
    const dist = parseFloat(distance);
    if (isNaN(paceMin) || isNaN(paceSec) || isNaN(dist) || dist <= 0) {
      setFinishTime('페이스와 거리를 올바르게 입력하세요.');
      return;
    }
    const totalPaceSeconds = paceMin * 60 + paceSec;
    if (totalPaceSeconds === 0) {
      setFinishTime('페이스는 0보다 커야 합니다.');
      return;
    }
    const totalFinishSeconds = totalPaceSeconds * dist;
    const hours = Math.floor(totalFinishSeconds / 3600);
    const minutes = Math.floor((totalFinishSeconds % 3600) / 60);
    const seconds = Math.floor(totalFinishSeconds % 60);
    const formattedTime = `${String(hours).padStart(2, '0')}시간 ${String(minutes).padStart(2, '0')}분 ${String(seconds).padStart(2, '0')}초`;
    setFinishTime(formattedTime);
  };

  return (
    <>
      <CssBaseline />
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6">마라톤 페이스/속도 계산기 (웹)</Typography>
        </Toolbar>
      </AppBar>
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Stack spacing={3}>
          <Card>
            <CardContent>
              <Typography variant="h5" component="div" gutterBottom>
                페이스 & 속도
              </Typography>
              <Stack spacing={2}>
                <Stack direction="row" spacing={2} alignItems="center">
                  <TextField
                    label="분/km"
                    type="number"
                    value={paceMinutes}
                    onChange={handlePaceMinutesChange}
                    variant="outlined"
                    fullWidth
                  />
                  <Typography variant="h4">:</Typography>
                  <TextField
                    label="초/km"
                    type="number"
                    value={paceSeconds}
                    onChange={handlePaceSecondsChange}
                    variant="outlined"
                    fullWidth
                  />
                </Stack>
                <TextField
                  label="속도 (km/h)"
                  type="number"
                  value={speed}
                  onChange={handleSpeedChange}
                  variant="outlined"
                  fullWidth
                />
              </Stack>
            </CardContent>
          </Card>

          <Card>
            <CardContent>
              <Typography variant="h5" component="div" gutterBottom>
                목표 거리
              </Typography>
              <TextField
                label="거리 (km)"
                type="number"
                value={distance}
                onChange={(e) => setDistance(e.target.value)}
                variant="outlined"
                fullWidth
                sx={{ mb: 2 }}
              />
              <Stack direction="row" spacing={1} justifyContent="center">
                <Button variant="outlined" onClick={() => setDistance('10')}>10km</Button>
                <Button variant="outlined" onClick={() => setDistance('21.0975')}>하프</Button>
                <Button variant="outlined" onClick={() => setDistance('42.195')}>풀</Button>
              </Stack>
            </CardContent>
          </Card>

          <Button
            variant="contained"
            size="large"
            onClick={calculateFinishTime}
            fullWidth
          >
            예상 완주 시간 계산하기
          </Button>

          {finishTime && (
            <Card>
              <CardContent>
                <Typography variant="h5" component="div" gutterBottom>
                  계산 결과
                </Typography>
                <Typography variant="h6" component="p" align="center">
                  {finishTime}
                </Typography>
              </CardContent>
            </Card>
          )}
        </Stack>
      </Container>
    </>
  );
}

export default App;
